import { render, staticRenderFns } from "./BankaHesabiForm.vue?vue&type=template&id=18f5154a&scoped=true"
import script from "./BankaHesabiForm.vue?vue&type=script&lang=ts"
export * from "./BankaHesabiForm.vue?vue&type=script&lang=ts"
import style0 from "./BankaHesabiForm.vue?vue&type=style&index=0&id=18f5154a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5154a",
  null
  
)

export default component.exports